import { ReactNode } from 'react';

import { Flex, Box, Show } from 'shared';
import Spacer from 'shared_DEPRECATED/components/Spacer';
import { Nullable } from 'shared_DEPRECATED/types';
import { Picture } from 'shared_DEPRECATED/types/Picture';
import { getPictureUrl } from 'shared_DEPRECATED/utils';

import { ChallengeCardSprints } from 'features/challenge/components/ChallengeCardSprints';
import { ChallengeInfo } from 'features/challenge/components/Info';
import { useLastSprint } from 'features/sprint/hooks/useLastSprint';

type TGoalRepeatedChallengeCard = {
  title: string;
  picture: Nullable<Picture>;
  emoji: Nullable<string>;
  children: ReactNode;
  sprintIds?: string[];
};

export const GoalRepeatedChallengeCard = ({
  title,
  picture,
  emoji,
  children,
  sprintIds,
}: TGoalRepeatedChallengeCard) => {
  const currentSprint = useLastSprint();

  return (
    <Box
      width="100%"
      backgroundColor="var(--bgCompPrimary)"
      borderRadius="var(--border-radius)"
    >
      <Spacer size="sm">
        <Flex width="100%" justifyContent="space-between" alignItems="center">
          <Flex>
            <ChallengeInfo
              emoji={emoji}
              pictureUrl={getPictureUrl(picture)}
              title={title}
              isCropped={false}
            >
              <Show
                when={
                  Boolean(sprintIds?.length) && Boolean(currentSprint?.sprintId)
                }
              >
                <ChallengeCardSprints
                  sprintIds={sprintIds!}
                  currentSprintId={currentSprint?.sprintId!}
                />
              </Show>
            </ChallengeInfo>
          </Flex>
          {children}
        </Flex>
      </Spacer>
    </Box>
  );
};
